import React from 'react';
import { Image } from '../../../../wag-react/next-components/image';
import ShieldStarBold from '../../../../assets/icons/walker-profile/assets/shield-star.png';
import { Box, BoxProps } from '../../../../wag-react/next-components/box';
type Props = {
  containerProps?: BoxProps;
  isPromoted?: boolean;
  imgSrc: string;
};
export const WalkerAvatar = ({
  imgSrc,
  isPromoted = false,
  containerProps = {}
}: Props) => <Box position={['absolute', 'absolute', 'relative']} zIndex={1} width="fit-content" {...containerProps} data-sentry-element="Box" data-sentry-component="WalkerAvatar" data-sentry-source-file="WalkerAvatar.tsx">
    {isPromoted && <Image position="absolute" top="0" right={['2px', '4px', '10px']} src={ShieldStarBold} alt="profile-recommended" width={['16px', '22px', '28px']} height={['18px', '24px', '30px']} objectFit="cover" />}
    <Image width={['72px', '100px', '150px']} height={['72px', '100px', '150px']} borderRadius="100%" src={imgSrc} alt="profile" border="1px solid white" style={{
    objectFit: 'cover'
  }} data-sentry-element="Image" data-sentry-source-file="WalkerAvatar.tsx" />
  </Box>;